import { render, staticRenderFns } from "./VPNCallStatisticsPage.vue?vue&type=template&id=5cb94d52&scoped=true&"
import script from "./VPNCallStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./VPNCallStatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb94d52",
  null
  
)

export default component.exports